import { Tooltip } from '@elfsight/widget-modal';
import { mediaTypes } from '../../../constants';
import type { MediaValue } from '../../data/sources';
import { useSocialFeedSettings } from '../../utils';
import { ShadowIcon } from './ShadowIcon';

interface MediaTypeIconProps {
  type: MediaValue['type'] | undefined;
  withoutTooltip?: boolean;
  shadow?: boolean;
  size?: number;
}

export function MediaTypeIcon({
  type,
  shadow = true,
  withoutTooltip = false,
  ...forwardingProps
}: MediaTypeIconProps) {
  const { tooltipBackgroundColor, tooltipTextColor, font } =
    useSocialFeedSettings();
  const mediaType = type ? mediaTypes[type] : undefined;

  if (!mediaType) {
    return null;
  }

  const { icon: Icon, title } = mediaType;

  if (!Icon) {
    return null;
  }

  if (withoutTooltip) {
    return (
      <ShadowIcon
        component={Icon}
        fill="#fff"
        size={20}
        _shadow={shadow}
        {...forwardingProps}
      />
    );
  }

  return (
    <Tooltip
      title={title}
      background={tooltipBackgroundColor}
      fontColor={tooltipTextColor}
      font={font}
    >
      <ShadowIcon
        component={Icon}
        fill="#fff"
        size={20}
        _shadow={shadow}
        {...forwardingProps}
      />
    </Tooltip>
  );
}
